export const TestIds = {
  BackToTopButtonRoot: 'backToTopRoot',
  BackToTopButtonSvg: 'backToTopSvg',
} as const;
